import { defineMessages } from 'react-intl';
import type { LocalePerProduct } from 'contracts';

const seo: LocalePerProduct = {
  livejasmin: defineMessages({
    title: {
      id: 'pages.signup.registration.seo.livejasmin.title',
      defaultMessage: 'Signup',
    },
    description: {
      id: 'pages.signup.registration.seo.livejasmin.description',
      defaultMessage: 'Signup',
    },
  }),
  oranum: defineMessages({
    title: {
      id: 'pages.signup.registration.seo.oranum.title',
      defaultMessage: 'Signup',
    },
    description: {
      id: 'pages.signup.registration.seo.oranum.description',
      defaultMessage: 'Signup',
    },
  }),
};

const login: LocalePerProduct = {
  livejasmin: defineMessages({
    cta: {
      id: 'pages.signup.registration.login.livejasmin.cta',
      defaultMessage: 'Login',
    },
  }),
  oranum: defineMessages({
    cta: {
      id: 'pages.signup.registration.login.oranum.cta',
      defaultMessage: 'Login',
    },
  }),
};

const support: LocalePerProduct = {
  livejasmin: defineMessages({
    title: {
      id: 'pages.signup.registration.support.livejasmin.title',
      defaultMessage: 'Need some help? Get <a>Live Support</a>',
    },
  }),
  oranum: defineMessages({
    title: {
      id: 'pages.signup.registration.support.oranum.title',
      defaultMessage: 'Need some help? Contact <a>Customer Support</a>',
    },
  }),
};

export default {
  pages: {
    signup: {
      registration: {
        seo,
        login,
        support,
      },
    },
  },
};
